import { render, staticRenderFns } from "./CountryAddNew.vue?vue&type=template&id=5664a40c"
import script from "./CountryAddNew.vue?vue&type=script&lang=js"
export * from "./CountryAddNew.vue?vue&type=script&lang=js"
import style0 from "./CountryAddNew.vue?vue&type=style&index=0&id=5664a40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports